import React, { useState, useEffect } from "react";
import { Button, Form } from "reactstrap";
import { MetaTags } from "react-meta-tags";
import styles from "./LandingPage.module.css";
import logo from "../../assets/images/logo-limpia.png";
import { getConsultarInformes, postEnviarInformeManual, postEnviarInformeManualSinCredenciales } from "../../helpers/backend";
import Swal from 'sweetalert2';

function LandingPage() {
  const [formData, setFormData] = useState({ 
    cuentaContrato: "", 
    fecha: ""
  });
  const [isLoaded, setIsLoaded] = useState(false);

  const { cuentaContrato, fecha } = formData;

  useEffect(() => {
    // Trigger animations after component mounts
    setTimeout(() => setIsLoaded(true), 100);
  }, []);


  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validations
    if (!cuentaContrato.trim()) {
      console.warn("⚠️ Cuenta Contrato vacía");
      return;
    }

    if (!fecha.trim()) {
      console.warn("⚠️ Fecha vacía");
      return;
    }



    try {
    
      // Mostrar loading
      Swal.fire({
        title: 'Consultando informes...',
        text: 'Por favor espera mientras buscamos tu información',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      // Consultar informes con los parámetros
      const queryParams = `?cuenta_contrato=${cuentaContrato}&fecha=${fecha}`;
      const response = await getConsultarInformes(queryParams);
            
      Swal.close();
      
      // Verificar si hay informes PDF disponibles
      if (response.data && response.data.informes_pdf && response.data.informes_pdf.length > 0) {
        // Mostrar mensaje de éxito y solicitar teléfono
        const { value: phoneData } = await Swal.fire({
          title: '¡Informe encontrado!',
          text: response.data.message || `Se encontraron ${response.data.total_pdfs} informes PDF`,
          icon: 'success',
          html: `
            <div style="margin: 20px 0;">
              <p style="margin-bottom: 20px; color: #28a745; font-weight: 500;">
                ${response.data.message || `Se encontraron ${response.data.total_pdfs} informes PDF`}
              </p>
              <div style="text-align: left; margin-bottom: 15px;">
                <label style="display: block; margin-bottom: 5px; font-weight: 500; color: #495057;">Número de teléfono para envío</label>
                <div style="display: flex; border: 1px solid #ced4da; border-radius: 4px; overflow: hidden;">
                  <select 
                    id="country-select" 
                    style="padding: 8px; border: none; background: #f8f9fa; border-right: 1px solid #ced4da; outline: none;"
                  >
                    <option value="+57">🇨🇴 +57</option>
                    <option value="+1">🇺🇸 +1</option>
                    <option value="+52">🇲🇽 +52</option>
                    <option value="+34">🇪🇸 +34</option>
                    <option value="+54">🇦🇷 +54</option>
                    <option value="+56">🇨🇱 +56</option>
                    <option value="+51">🇵🇪 +51</option>
                    <option value="+58">🇻🇪 +58</option>
                    <option value="+593">🇪🇨 +593</option>
                    <option value="+591">🇧🇴 +591</option>
                  </select>
                  <input 
                    id="phone-input" 
                    type="tel" 
                    placeholder="300 123 4567"
                    style="flex: 1; padding: 8px 12px; border: none; outline: none; font-size: 14px;"
                  />
                </div>
              </div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: 'Enviar Informe',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#6c757d',
          didOpen: () => {
            const phoneInput = document.getElementById('phone-input');
            const countrySelect = document.getElementById('country-select');
            
            // Función para formatear el número
            const formatPhoneNumber = (value) => {
              const numbers = value.replace(/\D/g, '');
              if (numbers.length <= 3) return numbers;
              if (numbers.length <= 6) return numbers.slice(0, 3) + ' ' + numbers.slice(3);
              return numbers.slice(0, 3) + ' ' + numbers.slice(3, 6) + ' ' + numbers.slice(6, 10);
            };
            
            // Event listener para formatear mientras se escribe
            phoneInput.addEventListener('input', (e) => {
              const formatted = formatPhoneNumber(e.target.value);
              e.target.value = formatted;
            });
          },
          preConfirm: () => {
            const countryCode = document.getElementById('country-select').value;
            const phoneNumber = document.getElementById('phone-input').value;
            
            if (!phoneNumber.trim()) {
              Swal.showValidationMessage('El número de teléfono es obligatorio');
              return false;
            }
            
            const numbersOnly = phoneNumber.replace(/\D/g, '');
            if (numbersOnly.length < 7 || numbersOnly.length > 15) {
              Swal.showValidationMessage('Ingrese un número de teléfono válido (7-15 dígitos)');
              return false;
            }
            
            return {
              countryCode: countryCode,
              phoneNumber: numbersOnly,
              fullNumber: countryCode + numbersOnly
            };
          }
        });
        
        if (phoneData) {
          try {
            // Mostrar loading para envío
            Swal.fire({
              title: 'Enviando informe...',
              text: 'Por favor espera mientras enviamos el informe a tu teléfono',
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
            
            // Enviar informe usando el caso_id del primer informe
            const casoId = response.data.informes_pdf[0].caso_id;
            const envioResponse = await postEnviarInformeManualSinCredenciales({
              phone: phoneData.fullNumber,
              caso_id: casoId
            });
            
            Swal.close();
            
            if (envioResponse.status === 200) {
              Swal.fire({
                title: '¡Informe Enviado!',
                text: `El informe ha sido enviado exitosamente al ${phoneData.fullNumber}`,
                icon: 'success',
                confirmButtonText: 'Cerrar',
                confirmButtonColor: '#28a745'
              });
            } else {
              throw new Error('Error en la respuesta del servidor');
            }
          } catch (envioError) {
            console.error('Error al enviar informe:', envioError);
            Swal.close();
            Swal.fire({
              title: 'Error',
              text: envioError.response?.data?.error || 'No se pudo enviar el informe. Intenta nuevamente.',
              icon: 'error',
              confirmButtonText: 'Cerrar',
              confirmButtonColor: '#dc3545'
            });
          }
        }
      } else {
        // No se encontraron informes
        Swal.fire({
          title: 'Sin resultados',
          text: 'No se encontraron informes para la cuenta contrato y fecha especificadas.',
          icon: 'info',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#17a2b8'
        });
      }
      
    } catch (error) {
      console.error("❌ Error al consultar informes:", error);
      Swal.close();
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al consultar los informes. Por favor intenta nuevamente.',
        icon: 'error',
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#dc3545'
      });
    }
  };

  return (
    <div className={styles.wrapper}>
      <MetaTags>
        <title>Ciudad Limpia | Bienvenido</title>
      </MetaTags>

      {/* Animated background particles */}
      <div className={styles.particlesContainer}>
        {[...Array(20)].map((_, i) => (
          <div 
            key={i} 
            className={styles.particle}
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>

      <div className={styles.overlay}>
        {/* Logo container with animation */}
        <div className={`${styles.logoContainer} ${isLoaded ? styles.fadeInDown : ''}`}>
          <img src={logo} alt="Ciudad Limpia" className={styles.logo} />
        </div>

        {/* Form card with animation */}
        <div className={`${styles.formCard} ${isLoaded ? styles.fadeInUp : ''}`}>
          <div className={styles.cardHeader}>
            <h2>Consulta de Acta de Visita</h2>
            <p>Consulta y obtén el acta de tu visita de servicio</p>
          </div>


          <Form onSubmit={onSubmit} className={styles.form}>
            <div className={styles.inputGroup}>
              <label htmlFor="cuentaContrato" className={styles.label}>
                Número de Cuenta Contrato
              </label>
              <input
                className={styles.input}
                type="text"
                id="cuentaContrato"
                name="cuentaContrato"
                placeholder="Ingrese el número de cuenta contrato del servicio"
                value={cuentaContrato}
                onChange={onChange}
                required
              />
              <div className={styles.inputUnderline}></div>
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="fecha" className={styles.label}>
                Fecha de la Visita
              </label>
              <input
                className={styles.input}
                type="date"
                id="fecha"
                name="fecha"
                value={fecha}
                onChange={onChange}
                required
              />
              <div className={styles.inputUnderline}></div>
            </div>



            <Button 
              type="submit" 
              className={styles.submitButton}
              disabled={!cuentaContrato.trim() || !fecha.trim()}
            >
              <span className={styles.buttonText}>Consultar Acta de Visita</span>
              <div className={styles.buttonRipple}></div>
            </Button>
          </Form>

          <div className={styles.footer}>
            <p>¿Necesitas ayuda? <a href="#!">Contáctanos</a></p>
          </div>
        </div>
      </div>

      {/* Floating elements for decoration */}
      <div className={styles.floatingElements}>
        <div className={`${styles.floatingElement} ${styles.element1}`}></div>
        <div className={`${styles.floatingElement} ${styles.element2}`}></div>
        <div className={`${styles.floatingElement} ${styles.element3}`}></div>
      </div>
    </div>
  );
}

export default LandingPage;
